import { isLotusAccount, isSystemAdminUser } from "/helpers/accounts.js";

//-- Release toggles for modules that are still being built, as navigation/admin-sections.js has for Administration sections.
//-- A module listed here as false is hidden from the navigation for everyone outside Lotus (its account and its staff). Flip it
//-- to true once the module is ready for customers. A module that isn't listed is not gated.
//-- This hides the menu entries only: the API still enforces each module's own permissions.
const releasedToCustomers = {
	projects: false,
	resourcing: false,
};


//-- Seats and add-ons that are not ready for customers yet. Like the modules above, they are hidden from everyone outside
//-- Lotus until released: not offered on a person's Permissions tab, not listed on Seats & inclusions. Remove a code from
//-- the list once it is ready to sell. Hidden, not stripped: a person who already holds one keeps it when their seats are saved.
const seatInclusionsNotReleasedToCustomers = ["Mobile", "Contributor", "TimeDelivery"];


/**
 * The rule on its own, so it can be read and tested without a signed-in user.
 *
 * @param {string} moduleKey A key of the release toggles above.
 * @param {boolean} isLotus Is the user in Lotus's own account, or Lotus staff?
 */
export function resolveModuleVisibleInNav(moduleKey, isLotus)
{
	if (releasedToCustomers[moduleKey] !== false) return true;

	return isLotus;
}


/**
 * Should the navigation show this module to the current user? The module's own access check (its Enabled feature and the
 * person's permissions) still applies as well.
 */
export function isModuleVisibleInNav(moduleKey)
{
	return resolveModuleVisibleInNav(moduleKey, isLotusAccount() || isSystemAdminUser());
}


/**
 * The seat rule on its own, so it can be read and tested without a signed-in user.
 *
 * @param {string} inclusionCode The seat or add-on's code ("Contributor", "TimeDelivery", ...).
 * @param {boolean} isLotus Is the user in Lotus's own account, or Lotus staff?
 */
export function resolveSeatInclusionVisible(inclusionCode, isLotus)
{
	if (!seatInclusionsNotReleasedToCustomers.includes(inclusionCode)) return true;

	return isLotus;
}


/**
 * Should the current user be shown this seat or add-on? A held seat is never removed by hiding it.
 */
export function isSeatInclusionVisible(inclusionCode)
{
	return resolveSeatInclusionVisible(inclusionCode, isLotusAccount() || isSystemAdminUser());
}
